import {
    HOST,
    QUERY_PROFILE_REQUEST,
    QUERY_PROFILE_FAIL,
    QUERY_PROFILE_SUCCESS
} from '../../types'

import i18n from "i18next"

// const AUTH_API_URL = `https://screen-stage.gpm-rtv${(i18n.language === 'en') ? '.com' : '.ru'}/api/v1/`;

export const getQyeryProjects = (token) => { 
    return dispatch => {
        try {
            dispatch({
                type: QUERY_PROFILE_REQUEST,
            })
            return fetch(`${HOST}/v1/customer/my-content-requests`, {
                method: "GET",
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (!data.all) {
                        throw new Error(data.message)
                    }
                    dispatch({
                        type: QUERY_PROFILE_SUCCESS,
                        payload: data
                    })
                    return data;
                })
                .catch(error => {
                    const message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    dispatch({
                        type: QUERY_PROFILE_FAIL,
                        payload: message
                    })
                })
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: QUERY_PROFILE_FAIL,
                payload: message
            })
            return Promise.reject();
        }
    }
}